/**
 * Stable sort/filter keys for document display status (Epic 10 shared vocabulary).
 */
export type DisplayStatusSortKey =
  | 'draft'
  | 'sent'
  | 'viewed'
  | 'partially_signed'
  | 'awaiting_payment'
  | 'paid'
  | 'partially_paid'
  | 'completed'
  | 'awaiting_your_signature'
  | 'awaiting_client_signature'
  | 'signed'
  | 'declined'
  | 'scheduled'
  | 'submitted'
  | 'failed'
  | 'expired'
  | 'overdue'
  | 'in_progress';

/** Viewer context for audience-specific label phrasing (10.1 exception). */
export type DisplayStatusViewer = 'business' | 'client';

/**
 * Canonical display-status states shared by main-app and portal projectors.
 * Map domain logic to one of these, then call `resolveDisplayStatusLabel`.
 */
export const DISPLAY_STATUS_LABEL_STATES = {
  DRAFT: 'draft',
  SENT: 'sent',
  VIEWED: 'viewed',
  PARTIALLY_SIGNED: 'partially_signed',
  AWAITING_PAYMENT: 'awaiting_payment',
  PAID: 'paid',
  PARTIALLY_PAID: 'partially_paid',
  COMPLETED: 'completed',
  AWAITING_YOUR_SIGNATURE: 'awaiting_your_signature',
  AWAITING_CLIENT_SIGNATURE: 'awaiting_client_signature',
  AWAITING_BUSINESS_OWNER_SIGNATURE: 'awaiting_business_owner_signature',
  PAID_AWAITING_SIGNATURE: 'paid_awaiting_signature',
  SIGNED: 'signed',
  DECLINED: 'declined',
  SCHEDULED: 'scheduled',
  SUBMITTED: 'submitted',
  FAILED: 'failed',
  VOIDED: 'voided',
  EXPIRED: 'expired',
  OVERDUE: 'overdue',
  PAYMENT_DUE: 'payment_due',
  IN_PROGRESS: 'in_progress',
  NEW: 'new',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
} as const;

export type DisplayStatusLabelState =
  (typeof DISPLAY_STATUS_LABEL_STATES)[keyof typeof DISPLAY_STATUS_LABEL_STATES];

export interface DisplayStatusLabelResult {
  label: string;
  sortKey: DisplayStatusSortKey;
}

export interface ResolveDisplayStatusLabelInput {
  state: DisplayStatusLabelState;
  viewer: DisplayStatusViewer;
}

/** Card / primary-chip collapse for Living Sent File. Exactly three states. */
export type DisplayStatusTier1 = 'draft' | 'in_progress' | 'completed';

export interface ResolveDisplayStatusTier1Input {
  sortKey?: DisplayStatusSortKey;
  variant?: string;
  state?: DisplayStatusLabelState;
  viewer?: DisplayStatusViewer;
}

export interface DisplayStatusTier1Result {
  tier: DisplayStatusTier1;
  label: string;
}
